export enum Type {
  PODCAST_REFRESH_FEED_REQUEST = 'app/podcast/PODCAST_REFRESH_FEED_REQUEST',
  PODCAST_REFRESH_FEED_FINISHED = 'app/podcast/PODCAST_REFRESH_FEED_FINISHED',
}
